import classNames from 'classnames'
import classes from './WaitlistInfo.module.scss'
import PropTypes from 'prop-types'
import WaitlistTooltip from './WaitlistTooltip'


const WaitlistInfo = ({ program }) => (
  <>
    <div
      className={classNames('d-flex align-items-center', classes.waitlistInfo)}
      data-for={`waitlistTooltip-${program.id}`}
      data-tip
    >
      <span className={classes.waitlistCount}>
        {program.waitlistedStudents.length} on waitlist
      </span>
    </div>
    <WaitlistTooltip program={program} />
  </>
)

WaitlistInfo.propTypes = {
  program: PropTypes.shape({
    id: PropTypes.number,
    waitlistedStudents: PropTypes.array,
  }),
}

export default WaitlistInfo
